/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-21 10:18:44
 * @LastEditTime: 2019-08-23 10:23:02
 * @LastEditors: Please set LastEditors
 */
'use strict'
let base;
switch (process.env.NODE_ENV) {
  case "development":
    base = "dev";
    break;
  case "test": // 外网测试环境
    base = "test";
    break;
  case "production":
    base = "product";
    break;
}
module.exports = {
  Edition: base,
  linkUrl: '',
  'dev': {
    axiosUrl: "https://nova-api.nova-x.ca",
    AppOrH5Url: "",
    staticState: "https://img.superex.live/",
    socketUrl : 'wss://nova-api.nova-x.ca/socket/ws'
  },
  'test': {
    axiosUrl: "https://test-api.superex.bike",
    AppOrH5Url: "",
    staticState: "https://img.superex.live/",
    socketUrl: 'wss://test-api.superex.bike/socket/ws'
  },
  'product': {
    axiosUrl: "https://api.superexchang.com",
    AppOrH5Url: "",
    staticState: "https://img.superex.live/",
    socketUrl: 'wss://api.superexchang.com/socket/ws'
  }
};



//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = 1wn0
// module chunks = 53